import React, { Component } from "react";
import { Modal, AutoComplete, Select, Input, message, Spin, Tooltip } from "antd";
import HighSearchInput from "../../common/HighSearchInput";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import SearchRetrieve from "../../common/SearchRetrieve.new";

const { Option } = Select;
const { TextArea } = Input;

let status = "add";

class UpdateDepartment extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        departmentList: [],
        hospitalOptions: [],
        clearDepartmentName: false,
        needCourtyardArea: false,
        CourtyardAreaList: [],
        unblindingReasonList: [],
    };

    show = (record, type) => {
        const { departmentLocalName, centerPharmacy, unblindingRisk, unblindingReason } = record;
        status = type;
        this.setState({
            params: {
                ...record,
                departmentName: departmentLocalName,
                centerPharmacy: typeof (centerPharmacy) == 'boolean' ? String(centerPharmacy) : undefined,
                unblindingRisk: typeof (unblindingRisk) == 'boolean' ? String(unblindingRisk) : undefined,
                unblindingReason: unblindingReason ? unblindingReason.split(',') : [],
            },
            visible: true,
            clearDepartmentName: false,
        }, () => {
            if (centerPharmacy !== undefined && centerPharmacy !== null) this.queryUnbindingReason(String(centerPharmacy));
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            departmentList: [],
            hospitalOptions: [],
            needCourtyardArea: false,
        });
    };

    queryDepartmentdata = (value) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { params: { hospitalMainId } } = this.state;
            const options = {
                method: "POST",
                url: API_URL.hospital.queryDepWhenAddDoctor,
                data: { limit: 20, hospitalId: hospitalMainId, hospitalDepName: value },
                dataType: "json",
                doneResult: (res) => {
                    const { datas } = res;
                    this.setState({ departmentList: datas });
                },
            };
            $.sendRequest(options);
        }, 300);
    };

    queryUnbindingReason = (centerPharmacy) => {
        if (!centerPharmacy) { return; }
        $.sendRequest({
            method: "POST",
            url: API_URL.hospital.queryUnbindingReason,
            data: { centerPharmacy, unblindingRisk: 'true' },
            dataType: "json",
            doneResult: (res) => {
                const { unbindingReason = {} } = res;
                const list = [];
                for (const key in unbindingReason) {
                    list.push({ value: key, label: unbindingReason[key] });
                }
                this.setState({ unblindingReasonList: list });
            },
        });
    };

    submit = () => {
        const { params } = this.state;
        const { departmentName, clinicalTrialStartTime, hospitalId, unblindingRisk, unblindingReason = [], unblindingRiskLevel } = params;
        if (!hospitalId) { message.warning("请选择医院"); return; }
        if (!departmentName) { message.warning("请输入科室"); return; }
        if (unblindingRisk === 'true' && !unblindingReason.length) { message.warning("请选择破盲原因"); return; }
        if (unblindingRisk === 'true' && !unblindingRiskLevel) { message.warning("请选择破盲风险等级"); return; }
        if (clinicalTrialStartTime) { params.clinicalTrialStartTime = clinicalTrialStartTime.slice(0, 10); }

        let url;
        if (status === 'edit') {
            url = API_URL.hospital.modifyHospitalDepartment;
        } else {
            url = API_URL.hospital.addHospitalDepartment;
            (hospitalId || []).map((item, index) => { params[`ids[${index}]`] = item });
        }

        // 构建提交数据
        const submitData = {
            ...params,
            mainCrcList: null,
            unblindingReason: unblindingReason.join(','),
        };

        this.setState({ loading: true });
        $.sendRequest({
            method: "POST",
            url,
            data: submitData,
            dataType: "json",
            doneResult: (res) => {
                message.success(status === 'edit' ? '修改科室成功' : '添加科室成功');
                this.setState({ loading: false }, () => { this.hide(); this.props.loadData(); });
            },
            errorResult: () => { this.setState({ loading: false }); },
        });
    };

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    };

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        const obj = {};
        if (key === "departmentName") {
            obj.clearDepartmentName = true;
        } else if (key === "courtyardArea") {
            params[key] = value;
            params.hospitalId = value;
            params.departmentName = '';
        } else if (key === "centerPharmacy") {
            if (value) { this.queryUnbindingReason(value); } else { this.setState({ unblindingReasonList: [] }); }
        } else if (key === "unblindingRisk") {
            params.unblindingReason = undefined;
            params.unblindingRiskLevel = undefined;
        } else if (key === 'unblindingReason') {
            if ((value || []).includes('CRC_DIRCET') || (value || []).includes('CONFIRM_CRC_DIRCET') || (value || []).includes('DEPARTMENT_CRC_DIRCET')) {
                params.unblindingRiskLevel = 'HIGH';
            } else { params.unblindingRiskLevel = undefined; }
        }
        this.setState({ ...obj, params });
    };

    handleHighSearchInputChange = (options, idName, optionsName) => {
        const { params, clearDepartmentName } = this.state;
        params.hospitalMainId = options.value;
        params[idName] = options.text;
        params.courtyardArea = undefined;
        const option = options.value;
        if (clearDepartmentName) { params.departmentName = ""; }
        const obj = {};
        if (option) { obj.clearDepartmentName = true; }
        this.setState({ ...obj, params, departmentList: [], [optionsName]: options }, () => {
            if (option) { this.state.params.hospitalMainId !== undefined && this.queryCourtyardAreaList(); }
        });
    };

    queryCourtyardAreaList = () => {
        if (this.timer) { clearTimeout(this.timer); }
        this.timer = setTimeout(() => {
            const { params: { hospitalMainId } } = this.state;
            $.sendRequest({
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: { hospitalMainId, isSelfResponsible: 'DIRECTOR_USER' },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    let { needCourtyardArea, params } = this.state;
                    needCourtyardArea = false;
                    datas.map(i => { if (i.courtyardArea) { needCourtyardArea = true; } });
                    params.hospitalId = [datas[0].hospitalId];
                    this.setState({ CourtyardAreaList: datas, needCourtyardArea, params }, () => { this.queryDepartmentdata(); });
                }
            });
        }, 300);
    }

    getContent = () => {
        const { userId } = sessionStorage;
        const { params, visible, departmentList, needCourtyardArea, CourtyardAreaList, unblindingReasonList } = this.state;
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>);
        const {
            hospitalMainId, hospitalName, departmentName, remark, courtyardArea,
            centerPharmacy, unblindingRisk, unblindingReason, unblindingRiskLevel,
        } = params;
        const isHighRiskLevel = (unblindingReason || []).includes('CRC_DIRCET') || (unblindingReason || []).includes('CONFIRM_CRC_DIRCET') || (unblindingReason || []).includes('DEPARTMENT_CRC_DIRCET');
        const asterisk = <span style={{ color: "red" }}>*</span>;
        const departmentOptions = departmentList.map((i) => (<Option key={i.hospitalDepartmentId} disabled>{i.departmentLocalName}</Option>));
        const unblindingReasonOptions = unblindingReasonList.map(el => (
            <Option value={el.value}><Tooltip overlayStyle={{ width: 160 }} placement="top" title={el.label}>{el.label}</Tooltip></Option>
        ));
        const searchParams = {};
        if (status !== 'edit') { searchParams.chargeUserId = userId; }
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}医院:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <SearchRetrieve
                                isEdit={status === 'edit'}
                                disabled={status === 'edit'}
                                keyword="hospitalName"
                                style={{ width: 260 }}
                                params={{ limit: 10, offset: 1, isSelfResponsible: 'DIRECTOR_USER' }}
                                placeholder="输入医院名称检索"
                                url={API_URL.hospital.queryHospitalMainList}
                                value={hospitalName}
                                config={{ id: 'hospitalMainId', name: 'hospitalMainName' }}
                                onChange={(options) => this.handleHighSearchInputChange(options, "hospitalName", "hospitalOptions")}
                            />
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>院区:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <Select mode="multiple" filterOption={false} onSearch={this.queryCourtyardAreaList}
                                style={{ width: 260 }} placeholder="请输入"
                                disabled={!needCourtyardArea || !hospitalMainId}
                                value={courtyardArea} onChange={value => this.handleSelectChange(value, 'courtyardArea')}
                                allowClear={true}>
                                {CourtyardAreaOptions}
                            </Select>
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>{asterisk}科室:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <AutoComplete placeholder="请输入" style={{ width: 260 }} value={departmentName}
                                disabled={!(status === 'edit') && (!needCourtyardArea ? !hospitalMainId : !courtyardArea)}
                                onChange={(value) => this.handleSelectChange(value, "departmentName")}>
                                {departmentOptions}
                            </AutoComplete>
                        )}
                    </div>
                </li>
                {/* 原有字段 */}
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>有无中心药房:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <Select allowClear={true} style={{ width: 260 }} disabled={status === 'edit'}
                                onChange={(value) => this.handleSelectChange(value, 'centerPharmacy')}
                                value={centerPharmacy} placeholder="请选择">
                                <Option value="true">有</Option><Option value="false">无</Option>
                            </Select>
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>有无破盲风险:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        {visible && (
                            <Select allowClear={true} style={{ width: 260 }}
                                onChange={(value) => this.handleSelectChange(value, 'unblindingRisk')}
                                value={unblindingRisk} placeholder="请选择">
                                <Option value="true">有</Option><Option value="false">无</Option>
                            </Select>
                        )}
                    </div>
                </li>
                {unblindingRisk === 'true' && (
                    <li className="modal-item">
                        <div className="item-left" style={{ width: "35%" }}>{asterisk}破盲原因:</div>
                        <div className="item-right" style={{ width: "65%" }}>
                            {visible && (
                                <Select mode="multiple" allowClear={true} style={{ width: 260 }}
                                    onChange={(value) => this.handleSelectChange(value, 'unblindingReason')}
                                    value={unblindingReason} placeholder="请选择">
                                    {unblindingReasonOptions}
                                </Select>
                            )}
                        </div>
                    </li>
                )}
                {unblindingRisk === 'true' && (
                    <li className="modal-item">
                        <div className="item-left" style={{ width: "35%" }}>{asterisk}破盲风险等级:</div>
                        <div className="item-right" style={{ width: "65%" }}>
                            {visible && (
                                <Select allowClear={true} disabled={isHighRiskLevel} style={{ width: 260 }}
                                    onChange={(value) => this.handleSelectChange(value, 'unblindingRiskLevel')}
                                    value={unblindingRiskLevel} placeholder="请选择">
                                    <Option value="HIGH">高</Option><Option value="MIDDLE">中</Option><Option value="LOW">低</Option>
                                </Select>
                            )}
                        </div>
                    </li>
                )}
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>备注:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <TextArea value={remark} maxLength="200" placeholder="请输入" style={{ width: 220, height: 80 }}
                            onChange={(e) => this.handleInputChange(e, "remark")} />
                        <p style={{ width: 220, textAlign: "right", color: "#ccc" }}>{remark ? remark.length : 0}/200</p>
                    </div>
                </li>
            </ul>
        );
    };

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title={`${status === 'edit' ? "修改" : "添加"}科室`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="620px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: "0 20px" }}>{this.getContent()}</div>
                </Spin>
            </Modal>
        );
    }
}

export default UpdateDepartment;



// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/UpdateDepartment.js